export default __webpack_public_path__ + "static/media/murderbasement.048332e8.jpeg";